import { createIcon } from "@chakra-ui/react";

export const Lock = createIcon({
  displayName: "Lock",
  viewBox: "0 0 18 18",
  d: "M6.25 1.735c.69 0 1.25.554 1.25 1.236v1.235H5V2.97c0-.682.56-1.236 1.25-1.236zm-2.5 1.236v1.235c-.69 0-1.25.554-1.25 1.235v4.324c0 .681.56 1.235 1.25 1.235h5c.69 0 1.25-.554 1.25-1.235V5.44c0-.681-.56-1.235-1.25-1.235V2.97C8.75 1.606 7.63.5 6.25.5s-2.5 1.106-2.5 2.47zm2.969 3.86v1.544a.465.465 0 0 1-.469.463.465.465 0 0 1-.469-.463V6.831c0-.257.21-.463.469-.463.26 0 .469.206.469.463z",
  defaultProps: {
    "aria-label": "A lock icon representing security or privacy"
  }
});

export default Lock;

